module.exports = __webpack_public_path__ + "static/media/smartmockups_k0p0x1ab.3a8ec3f2.png";